import { useTranslation } from 'react-i18next'
import { ListRepairOrders } from '~/features/RepairOrders/ListRepairOrders'
import { Container, PageContainer } from '~/shared/ui/Layout'

export const ListRepairOrdersPage = () => {
  const { t } = useTranslation()

  return (
    <PageContainer title={t('repair orders')}>
      <Container>
        <ListRepairOrders />
      </Container>
    </PageContainer>
  )
}
